import * as React from "react";
import {Business, CurrentUser, MenuSection} from "../../../types/Types";
import {useState} from "react";
import {useEffect} from "react";
import {collection, getDocs, limit, orderBy, query, where} from "@firebase/firestore";
import {db} from "../../../firebase/FirebaseProvider";
import {getLocation} from "../../../utils/Utils";
import MenuSectionRow from "../../../pages/menu/MenuSectionRow";
import "./LocationMenu.css"
import DisplayListControl from "../../list/DisplayListControl";

interface Props {
  currentUser: CurrentUser,
  businessMap: Map<string, Business>,
  businessId: string
  displayConfigButtons: boolean,
}

function LocationMenu(props: Props) {
  const [menuSections, setMenuSections] = useState<Array<MenuSection>>([]);
  const [displayList, setDisplayList] = useState<boolean>(true);

  useEffect(() => {(async () => {
    if(!getLocation(props.businessId, props.businessMap)) {
      return
    }
    let menuSections = new Array<MenuSection>();
    const menuSectionCollections = query(
        collection(db, 'menu-sections'),
        where("location", "==", getLocation(props.businessId, props.businessMap)),
        orderBy("order", "asc"),
        limit(200),
    );
    const menuSectionsSnapshot = await getDocs(menuSectionCollections);
    menuSectionsSnapshot.forEach((doc) => {
      menuSections.push(doc.data() as MenuSection);
    });
    setMenuSections(menuSections);
  })();
  }, []);

  return (
      <div className={"mt-3"}>
        {<div className={`list-title ${displayList ? "" : "mb-0"}`} onClick={() => {}}>
            <b>Menu</b>
            {/*<DisplayListControl displayList={displayList} count={undefined} />*/}
        </div>}
        {displayList && menuSections.length > 0 && <div className={`mt-3 location-menu`}>
          {<div className={"centre-align menu-title"}>Food & Drink</div>}
          {menuSections.map((menuSection, index) => (
              <div className={`${index == menuSections.length-1 ? 'mb-0' : 'mb-2'}`}>
                <MenuSectionRow currentUser={props.currentUser} businessMap={props.businessMap} menuSection={menuSection} displayConfigButtons={props.displayConfigButtons}/>
              </div>
          ))}
        </div>}
      </div>
  )
}

export default LocationMenu;